// Returns the closest point on a polyline to a given point
// point: [lat, lng], polyline: array of [lat, lng]
export function getClosestPointOnPolyline(point, polyline) {
    function toRad(x) {
        return x * Math.PI / 180;
    }
    function haversine(lat1, lon1, lat2, lon2) {
        const R = 6371000; // meters
        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }
    let minDist = Infinity;
    let closestPoint = null;
    for (let i = 0; i < polyline.length - 1; i++) {
        const [lat1, lon1] = polyline[i];
        const [lat2, lon2] = polyline[i + 1];
        // Project point onto segment
        const A = { x: lat1, y: lon1 };
        const B = { x: lat2, y: lon2 };
        const P = { x: point[0], y: point[1] };
        const AB = { x: B.x - A.x, y: B.y - A.y };
        const AP = { x: P.x - A.x, y: P.y - A.y };
        const ab2 = AB.x * AB.x + AB.y * AB.y;
        const ap_ab = AP.x * AB.x + AP.y * AB.y;
        let t = ab2 === 0 ? 0 : ap_ab / ab2;
        t = Math.max(0, Math.min(1, t));
        const proj = [A.x + AB.x * t, A.y + AB.y * t];
        const dist = haversine(P.x, P.y, proj[0], proj[1]);
        if (dist < minDist) {
            minDist = dist;
            closestPoint = proj;
        }
    }
    return closestPoint;
}
